import React from 'react';
import JobResults from './components/job-results';
import Facets from './components/facets';
import Provider from './components/jobs-wrapper';
import JobFilterModal from './components/job-filter-modal';
function App() {

  return (
      
      <Provider> 
        <section class="section-20 jobResultsFiltersWrap">
          <div class="container">
              <div class="row">
                  <Facets />
                  <JobResults />
                  {(window.innerWidth >= 768) && <JobFilterModal />}
              </div>
          </div>
        </section>
      </Provider>
 
  );
}

export default App;